// extracted by mini-css-extract-plugin
export default {"container":"ProfileTabButtons_container__Nu1qL","blur":"ProfileTabButtons_blur__Ha6Sl","button":"ProfileTabButtons_button__T8oxu","icon":"ProfileTabButtons_icon__PYL9Z"};